// src/components/SPanel/Home/MoreWidgets.jsx
//
// Încă câteva widget-uri pentru pagina principală: lecția următoare,
// notificările și de recapitulat.

import React from "react";

import { CountUp, Head, Skeleton, Tile } from "./HomeTile";
import { TagUI } from "../../UI";
import { formatCountdown, formatDayMonth, formatDriven, formatTime } from "./homeLessons";
import { openPopup } from "../../Common/popupUIStore";

import calendarIcon from "../../../assets/svg/mdi--calendar-outline.svg";
import bellIcon from "../../../assets/svg/mingcute--notification-line.svg";
import bookIcon from "../../../assets/svg/material-symbols--book-outline.svg";

/* ================= lecția următoare ================= */

// cutia și sectorul vin cu literă mică („manuală”); eticheta e inline-flex, deci fără ::first-letter
const capitalize = (text) => String(text).charAt(0).toUpperCase() + String(text).slice(1);

export function NextLessonWidget({ size, data }) {
   const { track, now } = data;
   const next = track.next;

   if (!next) {
      return (
         <Tile id="next" size={size} onClick={() => openPopup("sAddProg")} label="Programează o lecție">
            <Head icon={calendarIcon} title="Lecția următoare" />
            <div className="wd-next__empty">
               <strong>Nicio lecție programată</strong>
               <span className="wd-next__cta">Programează →</span>
            </div>
         </Tile>
      );
   }

   const when = formatDayMonth(next.start);
   const live = next.state === "live";
   const countdown = (
      <TagUI tone={live ? "success" : "accent"} size="md" dot={live} pulse={live} className="wd-countdown">
         {formatCountdown(next.start, next.end, now)}
      </TagUI>
   );
   const open = () => openPopup("eventInfo", { event: next.event });

   return (
      <Tile id="next" size={size} onClick={open} label={`Lecția următoare: ${when.day} ${when.month}, ${formatTime(next.start)}`}>
         <Head icon={calendarIcon} title="Lecția următoare" />
         {countdown}
         <div className="wd-next__main">
            <span className="wd-next__day">
               {when.day}
               <small>{when.month}</small>
            </span>
            <span className="wd-next__info">
               <span className="wd-next__weekday wd-roomy">{when.weekday}</span>
               <span className="wd-next__time">
                  {formatTime(next.start)}
                  <span className="wd-roomy"> – {formatTime(next.end)}</span>
               </span>
               <span className="wd-next__number wd-roomy">
                  Lecția {String(next.number).padStart(2, "0")}
               </span>
            </span>
         </div>
         <TagUI.Group className="wd-tags wd-roomy wd-roomy--flex">
            <TagUI tone="page" size="md">{formatDriven(Math.round((next.end - next.start) / 60000))}</TagUI>
            {next.plate && <TagUI tone="page" size="md">{next.plate}</TagUI>}
            {next.gearbox && <TagUI tone="page" size="md">{capitalize(next.gearbox)}</TagUI>}
         </TagUI.Group>
      </Tile>
   );
}

/* ================= notificări ================= */

export function NotificationsWidget({ size, data }) {
   const { unread } = data.notifications;
   const openAll = () => openPopup("notifications");

   return (
      <Tile id="notifications" size={size} onClick={openAll} label={`Notificări: ${unread} noi`}>
         <Head icon={bellIcon} title="Notificări" />
         <div className="wd-big">
            <span className="wd-big__num">
               <CountUp value={unread} />
            </span>
         </div>
         <span className="wd-caption">{unread === 1 ? "notificare nouă" : "notificări noi"}</span>
      </Tile>
   );
}


/* ================= de recapitulat ================= */

export function MistakesWidget({ size, data }) {
   const { practice } = data;
   if (!practice) {
      return (
         <Tile id="mistakes" size={size}>
            <Head icon={bookIcon} title="De recapitulat" />
            <Skeleton />
         </Tile>
      );
   }
   // întrebări „roșii”: răspunse, dar niciodată corect
   const red = Number(practice.summary?.red) || 0;
   return (
      <Tile id="mistakes" size={size} to="/student/test" label={`De recapitulat: ${red} întrebări greșite`}>
         <Head icon={bookIcon} title="De recapitulat" />
         <div className="wd-big">
            <span className="wd-big__num">
               <CountUp value={red} />
            </span>
         </div>
         <span className="wd-caption">
            {red === 0 ? "nicio întrebare greșită" : red === 1 ? "întrebare greșită" : "întrebări greșite"}
         </span>
      </Tile>
   );
}
